<template>
  <f7-page name="radioaktivita" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Rádioaktivita</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <div class="map-dt" v-if="mapGeoJsonDt">
      Posledné údaje z {{ mapGeoJsonDt_f }}
    </div>


    <l-map :zoom="zoom"
           :center="center"
           :options="mapOptions"
           ref="mapRA"
           class="ra-map"
    >
      <l-control-zoom position="bottomright"  ></l-control-zoom>
      <l-tile-layer
          ref="layerBg"
          :url="url"
          :attribution="attribution"
      />
      <l-tile-layer :url="borderUrl" />
      <l-geo-json
          ref="geoJsonLayer"
          :geojson="mapGeoJsonData"
          :options="mapGeoJsonOptions"
      />

      <l-control v-if="isGeolocationEnabled" :position="'bottomright'">
        <div class="leaflet-bar">
          <a @click="geoLocateMap" role="button"><i class="icon f7-icons" style="font-size: 22px;">placemark_fill</i></a>
        </div>
      </l-control>

      <l-control v-if="isGeolocationEnabled && extraParams.clearBtnVar" :position="'bottomright'">
        <div class="leaflet-bar">
          <a @click="clearMarker" role="button"><i class="icon f7-icons" style="font-size: 22px;">xmark</i></a>
        </div>
      </l-control>


    </l-map>


  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LImageOverlay, LMarker, LGeoJson,  LControlZoom, LControl } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import shmuMixin from "../js/mixin";
import geoLocationMixin from "../js/geoLocationMixin";


export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LGeoJson,
    LControlZoom,
    LControl
  },
  mixins: [
    shmuMixin,
    geoLocationMixin
  ],
  data: function () {
    return {
      lastUpdated: 0,
      tCheckInterval: null,
      isGeoJsonLoaded: false,
      mapGeoJsonDt: null,
      mapGeoJsonData: {
        "type": "FeatureCollection",
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        },
        "features": []
      },
      mapGeoJsonOptions: {
        onEachFeature:this.openDetailFromFeature,
        pointToLayer: this.makePoint,
      },
      mapOptions: {
        zoomControl: false,
        zoomSnap: 0.5,
        maxBounds: [[51.7, 25.79], [45.05, 10.6]],
        minZoom: 6,
        maxZoom: 12
      },
      zoom: 8,
      center: latLng(48.588714, 17.896843),
      url: SHMUconf.MAP_TILE_URL + 'data/datatiles/osm/v1/{z}/{x}/{y}.png',
      borderUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/hranice_sk/v1/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright" class="external">OpenStreetMap</a> contributors',

      // geolocation
      extraParams: {
        circleMarkerObject: null,
        pointMarkerObject: null,
        clearBtnVar: false
      },

    };
  },
  computed: {
    mapGeoJsonDt_f: function() {
      if (this.mapGeoJsonDt !== null) {

        let m_f = this.$moment.unix(this.mapGeoJsonDt).tz('Europe/Bratislava').utc().format();
        let m = this.$moment(m_f);
        let d = Date.UTC(m.year(), m.month(), m.date(), m.hours(), m.minutes(), m.seconds());
        return  this.$moment(d).format('DD.MM.YYYY HH:mm');

      }
      return '';
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-pocasie');
    this.$f7.accordion.open('.shmu-i-pocasie');
    this.$nextTick(() => {
      this.initMap();
    });


  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) {
        this.loadGeoJsonData();
      }

    },
    loadGeoJsonData: function() {
      const self = this;
      //console.log('loadZrazkyGeoJsonData')

      let cached_geojson = self.$ls.get('radioactivity_geojson');
      if (cached_geojson !== null) {
        self.mapGeoJsonData = Object.freeze(cached_geojson);
        self.isGeoJsonLoaded = true;
      } else {

        self.$f7.dialog.preloader('Načítavam...');
        Axios.get(SHMUconf.API_BASE_URL + 'meteo/getradiationgeojson', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.mapGeoJsonData = Object.freeze(response.data);
                self.isGeoJsonLoaded = true;
                self.lastUpdated = self.$moment().unix();
                self.$ls.set('radioactivity_geojson', self.mapGeoJsonData, 10 * 60 * 1000); //  10 minut
                // clearInterval(this.tCheckInterval);
                // this.tCheckInterval = setInterval(this.checkLastUpdated, 5 * 60 * 1000); // overujem kazdych 5 min

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať údaje o rádioaktivite', 'Nastala chyba');
              }
              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }
    },
    initMap() {
      const self = this;
      //this.$refs.mapZrazky.mapObject.ANY_LEAFLET_MAP_METHOD();
      // console.log('leafLet ZRAZKY init done...')

      this.$$('.leaflet-control-attribution a').each((i,item) => {
        self.$$(item).addClass('external')
      });

      this.$refs.mapRA.mapObject.invalidateSize();

      this.$refs.mapRA.mapObject.on('zoomend', function (e) {
        if (this.getZoom() > 8) {
          document.querySelectorAll(".b-name").forEach( function(el) { el.style.opacity =  1});
        } else {
          document.querySelectorAll(".b-name").forEach( function(el) { el.style.opacity = 0 });
        }
      });

      // geolocation
      this.locationMapInitEvents(this, this.$refs.mapRA.mapObject);




    },
    makePoint(feature, latlng) {
      const self = this;
      let props = feature.properties;

      let color_class = '';
      let val = props.prop_value;

      if (val === null) return;

      if (this.mapGeoJsonDt === null) {
        this.mapGeoJsonDt = props.prop_dt;
      } else if (this.mapGeoJsonDt > 0 && props.prop_dt > this.mapGeoJsonDt) {
        this.mapGeoJsonDt = props.prop_dt;
      }

      color_class = 'ra-green';
      if (props.prop_alarm === true) {
        color_class = 'ra-red';
      }

      let addon = '<small> nSv/h</small>';
      let ctnt = '';
      ctnt += '<div class="b-name">' + feature.properties.prop_name + '</div>';
      ctnt += '<div class="b-value '+color_class+'">' + val + addon +'</div>';


      let divIcon = L.divIcon({className: 'marker-box', html:ctnt, iconAnchor:[30,0]});
      let point = L.marker(latlng, {icon: divIcon});



      point.bindTooltip(feature.properties.prop_name, { direction:'top', offset: [0, 0] });

      return point;
    },
    openDetailFromFeature(feature, layer) {
      const self = this;
      layer.on({
        click: function (v) {
          self.$f7router.navigate('/radioaktivita/' + v.target.feature.id);
        }
      });

    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) >= 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    // geolocation
    geoLocateMap() {
      this.locationLocate(this, this.$refs.mapRA.mapObject, 10);
    },
    clearMarker() {
      this.locationClearMarker(this, this.$refs.mapRA.mapObject);
    },
    onLocationFound(e) {
      this.locationFound(this, this.$refs.mapRA.mapObject, e);
    },
    onLocationError(e) {
      this.locationError(this, e);
    }


  }

};
</script>

<style lang="scss">

.ra-map {
  width: 100%;
  height: 100%;
}


.marker-box {
  display: flex;
  flex-direction: column;
  /* min-width: 90px; */
  .b-name {
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    white-space: nowrap;
    text-shadow: -1px -1px 0 #000, 1px 1px 0 #000, -1px 1px 0 #000, 1px -1px 0 #000;
    opacity: 0;
  }
  .b-value {
    background-color: #ffffff;
    color: #000;
    border: 1px solid #aaaaaa;
    text-align: center;
    border-radius: 3px;
    min-width: 55px;
    padding: 3px 2px;
    font-weight:bold;
    font-size: 12px;
    display: inline-block;
    line-height: 100%;
  }

  .ra-green {
    background-color: rgba(38,138,38,1);
    color: #ffffff;
  }

  .ra-red {
    background-color: rgba(204,59,0,1);
    color: #ffffff;
  }

  .ra-grey {
    background-color: rgb(194,185,188);
    color: #000000;
  }


  small {
    letter-spacing: 0px;
    font-weight: normal;
  }

}





.map-dt {
  font-size:12px;
  position: absolute;
  bottom: 3px;
  left: 3px;
  background: rgba(255,255,255,0.7);
  color: black;
  padding: 3px 7px;
  border: 1px solid #e2e2e2;
  z-index:1001;
}


</style>
